import * as React from 'react';
import { BeesInvoiceModel } from '../models/BeesInvoiceModel';
import logo from "../../../assets/images/bees.jpg";
import { Utils } from '../../common/views/Utils';

interface IBeesInvoicePrintViewProps {
    invoice: BeesInvoiceModel;
    invoiceNo: string;
}

interface IBeesInvoicePrintViewState {
}

export default class BeesInvoicePrintView
    extends React.Component<IBeesInvoicePrintViewProps, IBeesInvoicePrintViewState> {
    private _columnA = "60px";
    private _columnB = "220px";
    private _columnC = "230px";
    private _columnD = "120px";
    private _columnE = "180px";
    private _columnF = "220px";

    private _columnAB = "280px";
    private _columnC_F = "750px";
    private _columnA_D = "630px";
    private _columnBC = "450px";
    private _columnA_E = "810px";

    constructor(props: IBeesInvoicePrintViewProps) {
        super(props);

        this.state = {};
    }

    render() {
        return <div className="left" style={{ fontSize: "large", width: "1040px" }}>
            {this.header()}
            {this.contactInfo()}

            {this.invoiceNoRow()}
            {this.dateRow()}

            {this.gridHeader()}
            {this.itemRow()}

            {this.totalDollar()}
            {this.totalRiels()}

            {this.exchangeRateRow()}
            {this.signature()}
        </div>;
    }

    private header = () => {
        return <div>
            <div className="grid-col center" style={{ width: this._columnAB }}>
                <img src={logo} alt="Bees Express" width={155} />
            </div>
            <div className="grid-col left" style={{ width: this._columnC_F }}>
                <div style={{ fontSize: "xxx-large", fontFamily: "Khmer OS" }}>ប៊ី  អេចប្រេស សបភីង អេជេន</div>
                <div style={{ fontSize: "xx-large", fontWeight: "bold", fontFamily: "Time-New-Roman" }}>BEES EXPRESS SHOPPING AGENT</div>
            </div>
        </div>;
    }

    private contactInfo = () => {
        return <div className="text-block" style={{ paddingTop: 60 }}>
            <div className="default-font">E009-2400001675</div>
            <div className="default-font-kh">​​​​​​​​​​​​​​​​​​​អាសយដ្ឋាន: បុរីអរគីដេដឺរ៉ូយ៉ាល់ ផ្ទះលេខ ១០ ផ្លូវ ណាគ្រី</div>
            <div className="default-font-kh" style={{ paddingLeft: 105 }}>ភូមិ ត្រពាំងឈូក សង្កាត់ អូរបែកក្អម</div>
            <div className="default-font-kh" style={{ paddingLeft: 105 }}>ខណ្ឌ សែនសុខ រាជធានីភ្នំពេញ</div>

            <div className="default-font-kh">ទូរស័ព្ទលេខ: <span className="default-font">070-717-255​ / 092-727-155</span></div>
            <div className="default-font-kh">អ៊ីម៉ែល: <span className="default-font">sengbora2010@gmail.com</span></div>

            <div className="center default-font-kh font-bold" style={{ fontSize: "x-large" }}>វិក័យបត្រ</div>
            <div className="center default-font font-bold" style={{ fontSize: "x-large", marginTop: -10 }}>INVOICE</div>
        </div>;
    }

    private invoiceNoRow = () => {
        const { invoice, invoiceNo } = this.props;

        return <div className="pt-10">
            <div className="grid-col left" style={{ width: this._columnA_D, height: 70 }}>
                <div className="pt-5 default-font-kh">អតិថិជន: <span className="default-font">{invoice.name}</span></div>
                <div className="default-font-kh">ទូរសព្ទលេខ: <span className="default-font">{Utils.formatPhone(invoice.phoneNo)}</span></div>
            </div>

            <div className="grid-col ph-10 border left" style={{ width: this._columnE, height: 70 }}>
                <div className="pt-5 default-font-kh">លេខវិក្កយបត្រ​៖</div>
                <div className="default-font">Invoice No:</div>
            </div>

            <div className="grid-col border center font-bold pt-25 default-font" style={{ width: this._columnF, height: 70 }}>
                {invoiceNo}
            </div>
        </div>;
    }

    private dateRow = () => {
        const { invoice } = this.props;

        return <div>
            <div className="grid-col left" style={{ width: this._columnA_D, height: 70 }}></div>

            <div className="grid-col ph-10 left border" style={{ width: this._columnE, height: 70 }}>
                <div className="pt-5  default-font-kh">កាលបរិច្ឆេទ៖</div>
                <div className="default-font">Date:</div>
            </div>

            <div className="grid-col border center default-font" style={{ width: this._columnF, height: 70, paddingTop: 22 }}>
                {invoice.strDate}
            </div>
        </div>;
    }

    private gridHeader = () => {
        return <div className="font-bold" style={{ paddingTop: 40, fontFamily: "Times New Roman" }}>
            <div className="pv-5 grid-col center border" style={{ width: this._columnA }}>
                <div className="default-font-kh">ល.រ</div>
                <div className="default-font">No.</div>
            </div>

            <div className="pv-5 grid-col center border" style={{ width: this._columnBC }}>
                <div className="default-font-kh">បរិយាយ</div>
                <div className="default-font">Particulars</div>
            </div>

            <div className="pv-5 grid-col center border" style={{ width: this._columnD }}>
                <div className="default-font-kh">បរិមាណ</div>
                <div className="default-font">Quantity</div>
            </div>

            <div className="pv-5 grid-col center border" style={{ width: this._columnE }}>
                <div className="default-font-kh">ថ្លៃឯកត្តា</div>
                <div className="default-font">Unit Price (US$)</div>
            </div>

            <div className="pv-5 grid-col center border" style={{ width: this._columnF }}>
                <div className="default-font-kh">សរុបរួមទាំងអាករ</div>
                <div className="default-font">Total with Tax (US$)</div>
            </div>
        </div>;
    }

    private itemRow = () => {
        const { invoice } = this.props;
        const height = 220;

        return <div>
            <div className="p-10 grid-col center default-font border" style={{ width: this._columnA, height: height }}>
                1
            </div>
            <div className="p-10 grid-col left default-font border" style={{ width: this._columnBC, height: height }}>
                Service Fee
            </div>
            <div className="p-10 grid-col center default-font border" style={{ width: this._columnD, height: height }}>
                1
            </div>
            <div className="p-10 grid-col right default-font border" style={{ width: this._columnE, height: height }}>
                {invoice.amount.toFixed(2)}
            </div>
            <div className="p-10 grid-col right default-font border" style={{ width: this._columnF, height: height }}>
                {this.getTotalText()}
            </div>
        </div>;
    }

    private totalDollar = () => {
        return <div className="font-bold">
            <div className="p-8 grid-col center default-font border" style={{ width: this._columnA_E, height: 50 }}>
                <span className="default-font-kh">សរុបរួម</span><span className="default-font"> Total (USD)</span>
            </div>
            <div className="ph-8 pt-15 grid-col right default-font border" style={{ width: this._columnF, height: 50 }}>
                {this.getTotalText()}
            </div>
        </div>;
    }

    private totalRiels = () => {
        const { invoice } = this.props;

        let strTotalDollar = this.getTotalText();
        let totalDollar = parseFloat(strTotalDollar);
        let totalRiels = Math.round(totalDollar * invoice.exchangeRate);

        return <div className="font-bold">
            <div className="p-8 grid-col center default-font border" style={{ width: this._columnA_E, height: 50 }}>
                <span className="default-font-kh">សរុបរួម</span><span className="default-font"> Total (Riel)</span>
            </div>
            <div className="ph-8 pt-15 grid-col right default-font border" style={{ width: this._columnF, height: 50 }}>
                {Utils.formatNumber(totalRiels)}
            </div>
        </div>;
    }

    private exchangeRateRow = () => {
        const { invoice } = this.props;

        return <div>
            <div className="p-10 grid-col" style={{ width: this._columnA }}></div>
            <div className="p-10 grid-col default-font" style={{ width: this._columnB }}>Exchange Rate 1 $ =  </div>
            <div className="p-10 grid-col default-font" style={{ width: this._columnC }}>{invoice.exchangeRate}</div>
        </div>;
    }

    private signature = () => {
        const height = 150;

        return <div>
            <div className="grid-col left" style={{ width: this._columnA_E }}>
                <div style={{ width: 250, borderBottom: "2px solid black", height: height }}></div>
                <div className="pv-10">ហត្ថលេខា និងឈ្មោះអ្នកទិញ</div>
                <div>Customer's Signature & Name</div>
            </div>

            <div className="grid-col left" style={{ width: this._columnF }}>
                <div className="center mb-20" style={{ width: 210, height: 130 }}>
                    {/*<img src={this.getSignature()} alt="" width={155} />*/}
                </div>
                <div style={{ width: 210, borderBottom: "2px solid black" }}></div>
                <div className="pv-10">ហត្ថលេខា និងឈ្មោះអ្នកលក់</div>
                <div>Seller's Signature & Name</div>
            </div>
        </div>;
    }

    //private getSignature = () => {
    //    const random = (1 + Math.floor(Math.random() * 5)); //1 + (0 -> 4) => 1 -> 5

    //    if (random === 1) return signature1;
    //    else if (random === 2) return signature2;
    //    else if (random === 3) return signature3;
    //    else if (random === 4) return signature4;
    //    else if (random === 5) return signature5;
    //}

    private getTotalText = () => {
        const { invoice } = this.props;
        return (invoice.amount * 1.1).toFixed(2);
    }
}